import React from 'react';
import PropTypes from 'prop-types';
import {fetchDecode} from "../../fetchUtils";
import {message} from "antd/lib/index";
import s from './Sent.css';
import { Dropdown, Icon, Input, Button, DatePicker, Table, LocaleProvider } from 'antd';
import Menu from 'antd/lib/menu';
import ui from '../../lang/ui.json';
import Breadcrumbs from "../../components/Breadcrumbs";

class BatchInfo extends React.Component{

    static propTypes = {
        locale: PropTypes.objectOf(PropTypes.string).isRequired
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            transaction: null,
            tableData: [],
            name: '',
            config: require('Config'),
            contacts: [],
            searchNumber: '',
            tempNumber: '',
            refreshIntervalId: '',
            clear: false,
        };
    }

    onSearch(clearSearch) {
        this.setState({ tableData: this.state.transaction.message_list.filter(message => message.msisdn === this.state.tempNumber)});
        this.setState({ clear: clearSearch});
        this.setState({ searchNumber: this.state.tempNumber});
    }

    componentDidMount() {
        this.fetchBatch();
        this.setState({refreshIntervalId: setInterval(()=> this.fetchBatch(), 10000)});
    }

    componentWillUnmount(){
        clearInterval(this.state.refreshIntervalId)
    }

    fetchBatch(){
        fetchDecode(this.state.config.serverUrl + `search/byId/${this.props.id}`, message)
            .then(transaction => {
            let messages = null;
            if (transaction){
                messages = transaction.message_list;
                if(this.state.tempNumber != ''){
                    messages = messages.filter(message => message.msisdn === this.state.tempNumber)
                }
                this.setState({ transaction: transaction, tableData: messages });
            }
        });
    }

    toggleSearch() {
        this.setState({ visible: !this.state.visible });
    }

    render() {
        const columns = [{
            title:this.props.locale.tableSender,
            dataIndex: 'msisdn',
            key: 'msisdn',
            sorter: (a, b) => {
                if (a.msisdn < b.msisdn) return -1;
                if (a.msisdn > b.msisdn) return 1;
                return 0;
            },
        },
        {
            title:this.props.locale.submitTime,
            dataIndex: 'submit_time',
            key: 'submit_time',
            sorter: (a, b) => {
                if (a.submit_time < b.submit_time) return -1;
                if (a.submit_time > b.submit_time) return 1;
                return 0;
            },
            render: (text) => {
                var d = new Date(text);
                var options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' };
                return d.toLocaleDateString("en-GB", options);
            }
        },
        {
            title: this.props.locale.messageStatus,
            dataIndex: 'submit_status_code',
            key: 'submit_status_code',
            sorter: (a, b) => {
                if (a.delivery_status < b.delivery_status) return -1;
                if (a.delivery_status > b.delivery_status) return 1;
                return 0;
            },
            render: (text, record, index) => {
                if (record.submit_status_code == '0') {
                    if(record.delivery_status == '' || record.delivery_status == null){
                        return <span className={s.green}>Skeyti á leiðinni</span>;
                    }
                    let className = s.orange;
                    if(record.delivery_status == "DELIVERED" || record.delivery_status == "ENROUTE" || record.delivery_status == "ACCEPTED" || record.delivery_status =="SCHEDULED")
                        className = s.green;
                    return <span className={className}>{this.props.locale.deliveryStatus[record.delivery_status]}</span>;
                }
                else{
                    return <span className={s.orange}>{this.props.locale.submitStatusCodes[record.submit_status_code]}</span>
                }
            },
        },
        {
            title:this.props.locale.terminationTime,
            dataIndex: 'termination_time',
            key: 'termination_time',
            sorter: (a, b) => {
                if (a.termination_time < b.termination_time) return -1;
                if (a.termination_time > b.termination_time) return 1;
                return 0;
            },
            render: (text) => {
                if(text != undefined) {
                    var d = new Date(text);
                    var options = {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit'
                    };
                    return d.toLocaleDateString("en-GB", options);
                }
                else {
                    return "";
                }
            }
        }];
        const searchForm = (
            <Menu selectable={false}>
                <Menu.Item>
                    <div className={s.search}>
                        <div className={s.search_row}>
                            <Input
                                placeholder={this.props.locale.searchMSISDN}
                                value={this.state.tempNumber}
                                onChange={(event) => { this.setState({ tempNumber: event.target.value }); }}
                                onPressEnter={() => { this.onSearch(true); }}
                            />
                            <Button
                                type="primary"
                                onClick={() => { this.onSearch(true); }}
                            >{this.props.locale.searchButton}</Button>
                        </div>
                    </div>
                </Menu.Item>
            </Menu>
        );
        return (
            <LocaleProvider locale={ui}>
                <div className={s.root}>
                    <Breadcrumbs title={this.props.locale.breadcrumbs} link="/sent" />
                    <div className={s.headline}>
                        <h1>{this.props.locale.batchInfo}</h1>
                        <div className={s.headline_cont}>
                            <Dropdown
                                className={s.search}
                                placement="bottomRight"
                                overlay={searchForm}
                                trigger={['click']}
                                visible={this.state.visible}
                            >
                                <div>
                                    {this.state.clear ?
                                        <button
                                            role="button"
                                            className={s.search_clear}
                                            onClick={() => {
                                                this.setState({searchNumber: ''});
                                                this.setState({tempNumber: ''});
                                                this.fetchBatch();
                                                this.setState({ clear: false });
                                            }}
                                        >Clear search</button>
                                        : ''}
                                    <Icon
                                        className={s.headline_icon}
                                        type="search"
                                        onClick={() => { this.toggleSearch(); }}
                                    />
                                </div>
                            </Dropdown>
                        </div>
                    </div>
                    <Table
                        className={s.table}
                        columns={columns}
                        dataSource={this.state.tableData}
                        rowKey="msisdn"
                    />
                </div>
            </LocaleProvider>
        );
    }
}
export default BatchInfo;


// WEBPACK FOOTER //
// ./src/routes/sent/BatchInfo.js